import type { IRecursive, ITokenSchema } from "@assets/theme/interfaces";

const borderRadius: IRecursive<ITokenSchema<string>> = {
  none: { value: "0" },
  base: { value: "8px" },
  table: { value: "12px" },
  full: { value: "9999px" },
};

export type Radius = typeof borderRadius;

export default borderRadius;
